import React from 'react';
import Icon from '@material-ui/icons/ErrorOutline';
import { Tooltip } from '@material-ui/core';

const ErrorIcon = ({ helperText }) => {
    return (
        <Tooltip arrow title={helperText}>
            <Icon color="error" className="icon-error" />
        </Tooltip>
    )
}

export default React.memo(ErrorIcon);